import { render, staticRenderFns } from "./DeveloperEditProjectAccess.vue?vue&type=template&id=c0fd3d88&scoped=true&"
import script from "./DeveloperEditProjectAccess.vue?vue&type=script&lang=js&"
export * from "./DeveloperEditProjectAccess.vue?vue&type=script&lang=js&"
import style0 from "./DeveloperEditProjectAccess.vue?vue&type=style&index=0&id=c0fd3d88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fd3d88",
  null
  
)

export default component.exports